import {
  GET_PREPARED_CARDS_PLANNING,
  GET_PREPARED_CARDS_PLANNING_SUCCESS,
  SET_PLANNING_IS_LOADING,
  GET_OCCURRENCES,
  GET_OCCURRENCES_SUCCESS,
  GET_ACTUAL_OCCURRENCE,
  GET_ACTUAL_OCCURRENCE_SUCCESS,
  GET_OCCURRENCES_BY_DATES_SUCCESS,
  GET_OCCURRENCES_BY_DATES,
  SELECT_PLANNING_VERSION,
  CLEAR_ACTUAL_OCCURRENCE,
  WAITING_SAVING,
} from "./constants"

export function getPreparedCardsPlanningAction(payload) {
  return {
    type: GET_PREPARED_CARDS_PLANNING,
    payload: payload,
  }
}

export function getPreparedCardsPlanningSuccessAction(payload) {
  return {
    type: GET_PREPARED_CARDS_PLANNING_SUCCESS,
    payload: payload,
  }
}

export function setPlanningIsLoadingAction(payload) {
  return {
    type: SET_PLANNING_IS_LOADING,
    payload: payload,
  }
}

export const getOccurrencesAction = payload => ({ type: GET_OCCURRENCES, payload: payload })
export const getOccurrencesSuccess = payload => ({
  type: GET_OCCURRENCES_SUCCESS,
  payload: payload,
})

export const getActualOccurrenceAction = payload => ({
  type: GET_ACTUAL_OCCURRENCE,
  payload: payload,
})
export const getActualOccurrenceSuccess = payload => ({
  type: GET_ACTUAL_OCCURRENCE_SUCCESS,
  payload: payload,
})

/** GET occurrences by dates */
export const getActualOccurrenceByDates = payload => ({
  type: GET_OCCURRENCES_BY_DATES,
  payload: payload,
})
export const getActualOccurrenceByDatesSuccess = payload => ({
  type: GET_OCCURRENCES_BY_DATES_SUCCESS,
  payload: payload,
})

export const clearActualOccurrenceAction = payload => ({ type: CLEAR_ACTUAL_OCCURRENCE })

export const selectPlanningVersionAction = payload => ({
  type: SELECT_PLANNING_VERSION,
  payload: payload,
})

export const setWaitingSavingAction = payload => ({
  type: WAITING_SAVING,
  payload: payload,
})
